"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotNullOrUndefined = void 0;
function isNotNullOrUndefined(input) {
    return input != null;
}
exports.isNotNullOrUndefined = isNotNullOrUndefined;
